<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 18 18" enable-background="new 0 0 18 18" xml:space="preserve">
  <polygon [attr.fill]="color" points="15 8 10 8 10 3 8 3 8 8 3 8 3 10 8 10 8 15 10 15 10 10 15 10 "/>
</svg>